import Stack from "@mui/material/Stack";
import { addDays, format, subMonths } from "date-fns";
import { map } from "lodash";
import { useCallback, useMemo } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

import { Scheduler } from "../../../components/Scheduler";
import { listArts } from "../../../services/studio";
import { RequestArtParams } from "../../../types/studio";

export function Calendar() {
  const navigate = useNavigate();
  const arts = useQuery("arts", async () => {
    const params: RequestArtParams = {
      endDate: addDays(new Date(), 1),
      startDate: subMonths(new Date(), 1),
    };

    return listArts(params);
  });

  const events = useMemo(() => {
    return map(arts.data, (art) => ({
      title: art.nome_tabloide_digital,
      date: format(new Date(art.data_insert.replace("Z", "")), "yyyy-MM-dd"),
      extendedProps: { ...art },
    }));
  }, [arts.data]);

  const handleEventClick = useCallback(
    (_: any) => {
      const event = _.event?.extendedProps;

      navigate(String(event?.id_tabloide_digital), {
        state: { name: event?.nome_tabloide_digital },
      });
    },
    [navigate]
  );

  return (
    <Stack spacing={2}>
      <Scheduler onEventClick={handleEventClick} events={events} />
    </Stack>
  );
}
